export function fetch(id) { return { type: 'ROOMS/FETCH', id } }
export function fetch_one(id) { return { type: 'ROOM/FETCH', id } }
export function archive(id, IdProperty) { return { type: 'ROOM/ARCHIVE', id, IdProperty } }
export function toggle(id, IsActive) { return { type: 'ROOM/TOGGLE', id, IsActive } }
export function clean() { return { type: 'ROOM/CLEAR' } }